import { FcProductName } from 'types';
import { BrandAccessRight, FcProductSuites } from '../brands/types';
import { RouteConfig } from './brand-shop-navigation/types';

export const retailersUrlPrefix = 'r';
export const brandShopUrlPrefix = 'brand';

export const brandShopBaseUrl = (brandId: string) => `/${retailersUrlPrefix}/${brandShopUrlPrefix}/${brandId}`;

export const brandShopFcProductPageRouteMapper = (brandId: string): Record<FcProductSuites, string> => {
    const baseUrl = brandShopBaseUrl(brandId);
    return {
        [FcProductSuites.Content]: `${baseUrl}/${FcProductSuites.Content}`,
        [FcProductSuites.Preorder]: `${baseUrl}/${FcProductSuites.Preorder}`,
        [FcProductSuites.Reorder]: `${baseUrl}/${FcProductSuites.Reorder}`,
        [FcProductSuites.AutoRestock]: `${baseUrl}/${FcProductSuites.AutoRestock}`,
        [FcProductSuites.Suggestions]: `${baseUrl}/${FcProductSuites.Suggestions}`,
        [FcProductSuites.Landing]: `${baseUrl}/${FcProductSuites.Landing}`
    };
};

export const accessRightsToBrandShopProductPageMapper = (brandId: string): Record<string, string> => {
    const baseUrl = brandShopBaseUrl(brandId);
    // TODO: Check with order team if this is correct
    return {
        [BrandAccessRight.ProductData]: `${baseUrl}/${FcProductSuites.Content}/products`,
        [BrandAccessRight.MarketingMaterial]: `${baseUrl}/${FcProductSuites.Content}/marketing`,
        [BrandAccessRight.ReorderPlatform]: `${baseUrl}/${FcProductSuites.Reorder}`,
        [BrandAccessRight.PreorderPlatform]: `${baseUrl}/${FcProductSuites.Preorder}/search`,
        [BrandAccessRight.EndlessAisle]: `${retailersUrlPrefix}/settings/clara/users`
    };
};

export const fcProductNameToFcProductSuiteMapper: Partial<Record<FcProductName, FcProductSuites>> = {
    [FcProductName.ContentPlatform]: FcProductSuites.Content,
    [FcProductName.PreorderPlatform]: FcProductSuites.Preorder,
    [FcProductName.OrderPlatform]: FcProductSuites.Reorder,
    [FcProductName.AutoRestock]: FcProductSuites.AutoRestock,
    [FcProductName.Suggestions]: FcProductSuites.Suggestions
};

export const getSelectedProductSuiteFromRoute = (url: RouteConfig['target']): FcProductSuites | undefined => {
    const segmentedUrl = Array.isArray(url) ? url : url.split('?')[0].split('/');
    const fcProductSuites = Object.values(FcProductSuites) as string[];

    return segmentedUrl.find((segment) => fcProductSuites.includes(segment));
};
